<template>
  <v-container fluid>
    <v-navigation-drawer app fixed clipped width="400">
      <template v-slot:prepend :elevation="3">
        <v-list-item>
          <v-list-item-title>{{ $t("search") }}</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item>
          <v-text-field prepend-inner-icon="mdi-magnify" rounded solo>
          </v-text-field>
        </v-list-item> -->
        <v-divider></v-divider>
      </template>
      <template v-slot:append :elevation="3">
        <v-divider></v-divider>
        <div class="d-flex pa-4">
          <v-btn color="primary" class="mr-4" @click="filter()">{{
            $t("apply_filter")
          }}</v-btn>
          <v-btn color="primary" @click="clearFilter()">{{
            $t("cancel")
          }}</v-btn>
        </div>
      </template>

      <div class="pa-2">
        <filter-part ref="filterView"> </filter-part>
      </div>
    </v-navigation-drawer>
    <div class="main-container" fill-height>
      <v-row class="ma-0 mb-2">
        <v-card class="form-container">
          <v-card-title class="flex justify-space-between">
            <v-btn color="primary" :outlined="selectedIdx != 0" @click="selectIdx(0)">待批准(对公转账)</v-btn>
            <v-btn color="primary" :outlined="selectedIdx != 1" @click="selectIdx(1)">未付款(微信)</v-btn>
            <v-btn color="primary" :outlined="selectedIdx != 2" @click="selectIdx(2)">驳回 </v-btn>
            <v-btn color="primary" :outlined="selectedIdx != 3" @click="selectIdx(3)">成功 </v-btn>
            <v-btn color="primary" :outlined="selectedIdx != 4" @click="selectIdx(4)">退款 </v-btn>
            <v-btn color="primary" :outlined="selectedIdx != 5" @click="selectIdx(5)">关闭 </v-btn>
            <v-btn color="primary" :outlined="selectedIdx != 6" @click="selectIdx(6)">全部 </v-btn>
          </v-card-title>
        </v-card>
      </v-row>
      <entity-view
        :item-schemas="itemSchemas"
        :readonly="readonly"
        :items="items"
        :title="$t('payment')"
        :pagination="pagination"
        :externalActions="externalActions"
        :options="options"
        @items-refresh="itemsRefresh"
        @item-action="itemAction"
        @page-change="pageChange"
        @double-click-row="clickRow"
      >
        <template v-slot:icon="item">
          <v-icon v-if="item.value" small color="success">
            mdi-check-circle
          </v-icon>
          <v-icon v-if="!item.value" small color="error">
            mdi-close-circle
          </v-icon>
        </template>
      </entity-view>
    </div>
    <input-dialog></input-dialog>
  </v-container>
</template>

<script>
import EntityView from "../components/EntityView.vue";
import InputDialog from "../components/InputDialog.vue";
import FilterPart from "./FilterPart.vue";
import PayementTypeDropdown from "../common/payment_type";
import PayementStatusDropdown from "../common/payment_status";
import CommonTypes from "../common/common_type";

export default {
  components: { EntityView, InputDialog, FilterPart },
  data: () => ({
    title: "Lawyer",
    select: true,
    expendOpen: false,
    readonly: true,
    selectedIdx: 0,
    expendFilter: {
      effected: {
        last: 10,
      },
    },
    pagination: {
      current: 1,
      pageCount: 1,
      pageSize: 10,
    },
    itemSchemas: [
      {
        name: "id",
        value: "id",
        type: "string",
        hasfilter: true,
        condition: {},
      },
      {
        name: "orderId",
        value: "orderId",
        type: "string",
      },
      {
        name: "paymentNo",
        value: "paymentNo",
        type: "string",
        hasfilter: true,
        condition: {},
      },
      {
        name: "type",
        value: "type",
        type: "dropdown",
        dropdown: PayementTypeDropdown.values,
        localized: true,
        hasfilter: true,
        condition: {},
      },
      {
        name: "amount",
        value: "amount",
        type: "number",
        hasfilter: true,
        condition: {},
      },
      {
        name: "userName",
        value: "userName",
        type: "string",
        hasfilter: true,
        condition: {},
      },
      {
        name: "lawyerName",
        value: "lawyerName",
        type: "string",
        hasfilter: true,
        condition: {},
      },
      {
        name: "isRefund",
        value: "isRefund",
        type: "dropdown",
        localized: true,
        dropdown: CommonTypes.booleans,
        hasfilter: true,
        condition: {},
      },
      {
        name: "status",
        value: "status",
        type: "dropdown",
        dropdown: PayementStatusDropdown.values,
        localized: true,
        hasfilter: true,
        condition: {},
      },
      {
        name: "createdAt",
        value: "createdAt",
        type: "datetime",
      },
    ],
    items: [],
    externalActions: [],
  }),
  mounted() {
    this.updateSchemaData();
    this.refresh();
  },
  computed: {
    options: function () {
      return {
        dateTimePattern: this.$root.$config.dateTimePattern,
        datePattern: this.$root.$config.datePattern,
        showAction: false,
      };
    },
  },
  methods: {
    updateSchemaData() {
      this.localizeSchema(this.itemSchemas);
      this.$refs.filterView.loadSchema(this.itemSchemas);
    },
    refresh() {
      let _this = this;
      let postData = {
        pagination: this.pagination,
        criterias: this.$refs.filterView.getCriterias(),
      };
      if (postData.criterias != undefined) {
        let status = [];
        let type = null;
        if (this.selectedIdx == 0) {
          status.push("notpay");
          type = "bill";
        } else if (this.selectedIdx == 1) {
          status.push("notpay");
          type = "wechat";
        } else if (this.selectedIdx == 2) {
          status.push("reject");
        } else if (this.selectedIdx == 3) {
          status.push("success");
        } else if (this.selectedIdx == 4) {
          status.push("refund");
        } else if (this.selectedIdx == 5) {
          status.push("close");
        }

        status.forEach((s) => {
          postData.criterias.push({
            operator: "=",
            type: "string",
            value: s,
            column: "status",
            condition: "or",
          });
        });
        if (type != null) {
          postData.criterias.push({
            operator: "=",
            type: "string",
            value: type,
            column: "type",
            condition: "and",
          });
        }
      }
      this.post("/api/payments?role=admin", postData, {
        callback: function (data) {
          let pg = {
            pageCount: data.data.pages,
            pageSize: data.data.size,
            current: data.data.current,
          };
          _this.pagination = pg;
          _this.items = data.data.records;
        },
      });
    },
    itemsRefresh() {
      this.refresh();
    },
    clickRow(item) {
      this.$router.push({
        name: "PaymentDetail",
        params: { id: item.id + "" },
      });
    },
    filter() {
      this.refresh();
    },
    clearFilter() {
      this.$refs.filterView.clear();
    },
    pageChange(pagination) {
      this.pagination = pagination;
      this.refresh();
    },
    itemAction(name) {
      if (name === "insert") {
        this.itemCreate();
      }
    },
    selectIdx(idx) {
      this.selectedIdx = idx;
      this.refresh();
    },
  },
};
</script>

<style scoped>
.filter-label {
  margin-left: -12px !important;
}
</style>

<i18n>
{
    "en": {
    "c_enable": "Is Online",
    "c_userId": "UserId"
  },
  "cn": {
    "c_enable": "是否在线",
    "c_userId": "客户ID"
  }
}
</i18n>
